import CustomButton from '../../../../features/customButton/ui/main/CustomButton';
import classNames from 'classnames';
import useButtonCallbacks from '../../model/hooks/useButtonCallbacks';
import content from '../../constants/content';
import { CLOTH } from '../../constants/types';

const { itemButtons } = content;

export default function ItemButtons({ type, is_equipped, id }) {
  const { onCloth } = useButtonCallbacks({ type, id, is_equipped });

  return {
    [CLOTH]() {
      return itemButtons.map((button, index) => (
        <CustomButton
          key={index}
          className={classNames(button.className, {
            'button_my-gift-equip': is_equipped,
            'button_my-gift-unequip': !is_equipped,
          })}
          text={!is_equipped && button.text.equip}
          icon={is_equipped && button.icon.equip}
          onClick={onCloth}
        />
      ));
    },
  }[type]?.();
}
